export const SET_ATTRIBUTE_AS_CHANGING = 'SET_ATTRIBUTE_AS_CHANGING';
export const UPDATE_CHANGING_ATTRIBUTES = 'UPDATE_CHANGING_ATTRIBUTES';
export const MARK_ATTRIBUTES_SET_AS_CHANGING = 'MARK_ATTRIBUTES_SET_AS_CHANGING';
export const UNMARK_ATTRIBUTES_SET_AS_CHANGING = 'UNMARK_ATTRIBUTES_SET_AS_CHANGING';

export const SET_ATTRIBUTES_SET_CHANGING_STATUS = 'SET_ATTRIBUTES_SET_CHANGING_STATUS';
export const SET_PRODUCTS_INDEX_STATUS = 'SET_PRODUCTS_INDEX_STATUS';
export const SET_PRODUCTS_DELETE_STATUS = 'SET_PRODUCTS_DELETE_STATUS';
export const SET_IMPORT_CATALOG_STATUS = 'SET_IMPORT_CATALOG_STATUS';
export const SET_IMPORT_DATA_STATUS = 'SET_IMPORT_DATA_STATUS';
export const SET_IMPORT_SOMEONE_CATALOG_STATUS = 'SET_IMPORT_SOMEONE_CATALOG_STATUS';
export const SET_DATA_INDEX_STATUS = 'SET_DATA_INDEX_STATUS';

export const SET_ADDING_NEW_DATA_STATUS = 'SET_ADDING_NEW_DATA_STATUS';
export const SET_ADDING_NEW_ADMIN_STATUS = 'SET_ADDING_NEW_ADMIN_STATUS';
export const SET_UPLOADING_FILES_STATUS = 'SET_UPLOADING_FILES_STATUS';
export const SET_IMPORT_UPLOADING_FILES_STATUS = 'SET_IMPORT_UPLOADING_FILES_STATUS';

// Перегенерация превью по шаблону (сокет-канал previewRegen)
export const SET_PREVIEW_REGEN_STATUS = 'SET_PREVIEW_REGEN_STATUS';
export const SET_PREVIEW_REGEN_PROGRESS = 'SET_PREVIEW_REGEN_PROGRESS';
export const CLEAR_PREVIEW_REGEN_PROGRESS = 'CLEAR_PREVIEW_REGEN_PROGRESS';

// Расширенные данные пайплайна индексации
export const SET_INDEX_PROGRESS = 'SET_INDEX_PROGRESS';
export const CLEAR_INDEX_PROGRESS = 'CLEAR_INDEX_PROGRESS';
export const SET_INDEX_LAST_ERROR = 'SET_INDEX_LAST_ERROR';
export const CLEAR_INDEX_LAST_ERROR = 'CLEAR_INDEX_LAST_ERROR';
export const SET_INDEX_HEALTH = 'SET_INDEX_HEALTH';

export const setAttributeAsChanging = (payload) => ({
  type: SET_ATTRIBUTE_AS_CHANGING,
  payload
});

export const updateChangingAttributes = (payload) => ({
  type: UPDATE_CHANGING_ATTRIBUTES,
  payload
});

export const markAttributesSetAsChanging = (id) => ({
  type: MARK_ATTRIBUTES_SET_AS_CHANGING,
  payload: id,
});

export const unmarkAttributesSetAsChanging = (id) => ({
  type: UNMARK_ATTRIBUTES_SET_AS_CHANGING,
  payload: id,
});

export const setAttributesSetChangingStatus = (status) => ({
  type: SET_ATTRIBUTES_SET_CHANGING_STATUS,
  payload: status,
});

export const setProductsIndexStatus = (status) => ({
  type: SET_PRODUCTS_INDEX_STATUS,
  payload: status,
});

export const setProductsDeleteStatus = (status) => ({
  type: SET_PRODUCTS_DELETE_STATUS,
  payload: status,
});

export const setDataIndexStatus = (status) => ({
  type: SET_DATA_INDEX_STATUS,
  payload: status,
});

export const setImportCatalogWorkerStatus = (status) => ({
  type: SET_IMPORT_CATALOG_STATUS,
  payload: status,
});

export const setImportDataWorkerStatus = (status) => ({
  type: SET_IMPORT_DATA_STATUS,
  payload: status,
});

export const setImportSomeOneCatalogStatus = (status) => ({
  type: SET_IMPORT_SOMEONE_CATALOG_STATUS,
  payload: status,
});

export const setAddingNewDataStatus = (status) => ({
  type: SET_ADDING_NEW_DATA_STATUS,
  payload: status,
});

export const setAddingNewAdminStatus = (status) => ({
  type: SET_ADDING_NEW_ADMIN_STATUS,
  payload: status,
});

export const setUploadingFilesStatus = (status) => ({
  type: SET_UPLOADING_FILES_STATUS,
  payload: status,
});

export const setImportUploadingFilesStatus = (status) => ({
  type: SET_IMPORT_UPLOADING_FILES_STATUS,
  payload: status,
});

/**
 * Идёт ли перегенерация превью. Задача асинхронная и долгая, а ответ ручки
 * возвращается сразу, поэтому состояние приходит сокетом и живёт в общем сторе —
 * иначе уход со страницы настроек «теряет» процесс.
 */
export const setPreviewRegenStatus = (status) => ({
  type: SET_PREVIEW_REGEN_STATUS,
  payload: status,
});

export const setPreviewRegenProgress = (payload) => ({
  type: SET_PREVIEW_REGEN_PROGRESS,
  payload,
});

export const clearPreviewRegenProgress = () => ({
  type: CLEAR_PREVIEW_REGEN_PROGRESS,
});

export const setIndexProgress = (payload) => ({
  type: SET_INDEX_PROGRESS,
  payload,
});

export const clearIndexProgress = () => ({
  type: CLEAR_INDEX_PROGRESS,
});

export const setIndexLastError = (payload) => ({
  type: SET_INDEX_LAST_ERROR,
  payload,
});

export const clearIndexLastError = () => ({
  type: CLEAR_INDEX_LAST_ERROR,
});

export const setIndexHealth = (payload) => ({
  type: SET_INDEX_HEALTH,
  payload,
});
